module.exports = __webpack_public_path__ + "static/img/about_4.eaf8b67.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/img/about_4.jpg
// module id = XG3V
// module chunks = 1